import { BaseSocketListener } from '~/web-frontend-core/api/connector/socketListener/BaseSocketListener';
const WS_KEY = 'debug:websocket';
const WS_URL = typeof window === 'undefined' ? '' :
    `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/wss`;
export class WSSocketListener extends BaseSocketListener {
}
WSSocketListener.createSocket = () => new WebSocket(localStorage.getItem(WS_KEY) || WS_URL);
WSSocketListener.toString = () => 'WSSocketListener';



// WEBPACK FOOTER //
// ./src/web-frontend-core/api/connector/socketListener/WSS.js